import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { RoversResponse } from '../models/rovers.model';

@Injectable({
  providedIn: 'root',
})
export class RoversService extends BaseApiService {
  getRovers(
    adults: number,
    children: number,
    railcards: string,
    outwardDepartureDateTime: string,
  ): Observable<RoversResponse> {
    const endpoint = `/rovers/${adults}/${children}/${railcards}/${outwardDepartureDateTime}`;
    return this.get<RoversResponse>(endpoint);
  }
}
